import Vue from 'vue'
import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'
import i18n from "@/helpers/i18n";


export interface State {
    organizers: any,
    organizer: any,
    loadStatus: boolean,
    loadStatusOrganizer: boolean,
    loadEdit: boolean,
    keyPublic:null|string,
    loadKey:boolean,
    loadAddOrg:boolean,
    loadAddUserOrg:boolean,
    loadDeleteUserOrg:boolean,
}

const defaultState: State = {
    organizers: null,
    organizer: null,
    loadStatus: false,
    loadStatusOrganizer: false,
    loadEdit: false,
    loadKey: false,
    loadAddUserOrg: false,
    loadAddOrg: false,
    loadDeleteUserOrg: false,
    keyPublic:null
};

const getters = {
    loadDeleteUserOrg: (state: State) => state.loadDeleteUserOrg,
    loadAddOrg: (state: State) => state.loadAddOrg,
    loadAddUserOrg: (state: State) => state.loadAddUserOrg,
    loadKey: (state: State) => state.loadKey,
    keyPublic: (state: State) => state.keyPublic,
    loadEdit: (state: State) => state.loadEdit,
    organizers: (state: State) => state.organizers,
    loadStatus: (state: State) => state.loadStatus,
    organizer: (state: State) => state.organizer,
    loadStatusOrganizer: (state: State) => state.loadStatusOrganizer
}

const mutations: MutationTree<State> = {
    keyPublicNull(state: State, payload: null|string) {
        state.keyPublic = payload
    },
    setOrganizers(state: State, payload: any[]) {
        state.organizers = payload
    },
    setOrganizer(state: State, payload: any[]) {
        state.organizer = payload
    },
    setLoadStatus(state: State, payload: boolean) {
        state.loadStatus = payload
    },
    setLoadStatusOrganizer(state: State, payload: boolean) {
        state.loadStatusOrganizer = payload
    },
    setOrganizerFromEdit(state: State, payload: any) {

    },
}

const actions: ActionTree<State, RootState> = {
    async deleteUserOrg({commit, state}, payload) {
        state.loadDeleteUserOrg = true
        try {
            const {data} = await Vue.axios.delete('/v5/admin/organizer/'+payload.orgId+'/employee/'+payload.userId)
            const elem = state.organizer.users.filter((el:any)=>el.id !== payload.userId)
            state.organizer.users = elem
            this.commit('alerts/setAlert', {
                show: true,
                messages: [i18n.t('organizers.dialog2.request')]
            })

        }catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                messages: [e.message]
            })
        }finally {
            state.loadDeleteUserOrg = false
        }
    },
    async addUserOrg({commit, state}, payload) {
        state.loadAddUserOrg = true
        try {
            const {data} = await Vue.axios.post('/v5/admin/organizer/'+payload._id+'/employee',{
                login:payload.login
            })
            state.organizer.users.unshift(data.data.user)
            this.commit('alerts/setAlert', {
                show: true,
                messages: [i18n.t('organizers.dialog2.norm')]
            })
        }catch (e) {

            this.commit('alerts/setAlert', {
                show: true,
                messages: [i18n.t('organizers.dialog2.not_found_user')]
            })
        }finally {
            state.loadAddUserOrg = false
        }
    },
    async addOrganizer({commit, state}, payload) {
        state.loadAddOrg = true
        try {
            const {data} = await Vue.axios.post('/v5/admin/organizer',{
                caption:payload
            })
            state.organizers.unshift(data.data.organizer)
        }catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e.message]
            })
        }finally {
            state.loadAddOrg = false
        }
    },
    async refreshKey({commit, state}, payload) {
        state.loadKey = true
        try {
            const {data} = await Vue.axios.patch('/v5/admin/organizer/'+payload+'/token')
            state.keyPublic = data.data.organizer.token.value
        }catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e.message]
            })
        }finally {
            state.loadKey = false
        }
    },
    async patchOrganizer({commit, state}, payload) {
        state.loadEdit = true
        try {
            const {data} = await Vue.axios.patch('/v5/admin/organizer/' + payload._id, {
                caption: payload.caption,
                note: payload.note
            })
            payload.caption = data.data.organizer.caption
            payload.note = data.data.organizer.note
            state.organizer = payload
            state.organizers.map((el: any) => {
                if (el._id == payload._id) {
                    el.note = payload.note,
                        el.caption = payload.caption
                }
                return el
            })

            this.commit('alerts/setAlert', {
                show: true,
                messages: [i18n.t('company.notifications.save_success')]
            })
        } catch (e) {
            state.organizers.map((el: any) => {
                if (el._id == payload._id) {
                   state.organizer.note = el.note
                   state.organizer.caption = el.caption
                }
                return el
            })
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e.message]
            })
        } finally {
            state.loadEdit = true
        }
    },
    async loadOrganizersFromServer({commit, state}) {
        if (state.organizers == null) {
            commit('setLoadStatus', true)
            try {
                const {data} = await Vue.axios.get('/v5/admin/organizers')
                commit('setOrganizers', data.data.organizers)
            } catch (e) {
                this.commit('alerts/setAlert', {
                    show: true,
                    color: 'red',
                    messages: [e.message]
                })
            }
            commit('setLoadStatus', false)
        }
    },
    async loadOrganizerFromServer({commit, state}, payload) {
        state.keyPublic = null
        commit('setLoadStatusOrganizer', true)
        try {
            const {data} = await Vue.axios.get('/v5/admin/organizer/' + payload)
            commit('setOrganizer', data.data.organizer)
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e.message]
            })
        } finally {
            commit('setLoadStatusOrganizer', false)
        }
    },

}

export default {
    namespaced: true,
    state: defaultState,
    getters,
    mutations,
    actions
}
